import React from 'react'

export default function ForeignInvest() {
  return (
    <div>ForeignInvest</div>
  )
}
